import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {setBlockNavigation} from '../redux/actions/newCourseActions';
import styles from '../styles/pages/marketSegments.module.scss';
import AmwayLogo from '../styles/images/amway_full_logo.svg';
import { assignSegmentId, fetchSegmentList, setSelectedSegment } from '../redux/actions/segment/segmentActions';
import { setAffiliateCode, setSelectedAffiliateCode } from '../redux/actions/roaster/roasterListingActions';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { setIsUserLoggedIn } from '../redux/actions/uiActions';
import config from '../config';
import { setMarketLanguages } from '../redux/actions/commonDataActions';
import MsalConfig from '../components/utils/EntraUtils/AuthConfig';

const MarketSegments = () => {
  const dispatch = useDispatch();
  const [isDropdown, setDropdown] = useState(false);
  const [dropdownVal, setDropdownVal] = useState(null);
  const history = useHistory();
  const { segmentsList = [] } = useSelector(state => state?.segment || {});

  const { oktaUserInfo,  marketLanguages = {} } = useSelector(state => state?.commonData || {});

  useEffect(() => {
    console.log('DEBUG config ', config)
    if(!config?.is_segmented) {
      history.push('/dashboard');
    }
    dispatch(setBlockNavigation(false));
    dispatch(setIsUserLoggedIn(false));
    dispatch(fetchSegmentList());
    // dispatch(setMarketLanguages({}))
  }, []);

  const handleSelected = (val) => {
    setDropdownVal(val);
    setDropdown(!isDropdown);
  };

  const handleCancel = () => {
    localStorage.clear();
    const msalConfig = new MsalConfig();
    msalConfig.logout();
    history.push('/login');
    dispatch(setIsUserLoggedIn(false));
  }

  const handleConfirm = () => {
    if(dropdownVal) {
      const assignedSegment = segmentsList.find((s) => s?.segmentId === dropdownVal.segmentId);
      
      const sales_plan_aff = 
        assignedSegment?.sales_plan_aff
        ?.split(',')
        .map((code) => ({salesPlanAffCode: code, id: code, name: code}));

      dispatch(setSelectedSegment(assignedSegment));
      dispatch(setAffiliateCode(sales_plan_aff));
      dispatch(setSelectedAffiliateCode(sales_plan_aff?.length ? sales_plan_aff[0] : {}));

      console.log('dropdownVal ', dropdownVal)

      dispatch(assignSegmentId({ countries: dropdownVal?.countries, history, oktaUserInfo, countryLabel: dropdownVal?.label, sales_plan_aff: dropdownVal?.sales_plan_aff }));
    }
  }

  const MarketSegmentsDropdown = (
    <div className={styles.form_wrapper}>
      <div className={styles.field}>
        <div className={styles.label}>Country*</div>
        <div className={`${styles.select_list_wrapper} ${isDropdown ? styles.open : ''}`}>
          <div
            className={`${styles.select_list} ${
              dropdownVal && dropdownVal?.label?.length > 0 ? styles.selected : ''
            }`}
            onClick={() => setDropdown(!isDropdown)}
          >
            {dropdownVal?.label || 'Select'}
            <div className={styles.down_arrow} />
          </div>

          {isDropdown && (
            <div className={styles.dropdown_container}>
              {segmentsList?.map((item, index) => (
                <div key={item?.segmentId} className={styles.item} onClick={() => handleSelected(item)}>
                  {item?.label || item?.countries}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className={styles.page_content}>
        <div className={styles.logo_container}>
          <img src={AmwayLogo} alt="Amway Logo" />
        </div>
        <div className={styles.box}>
          <h4 className={styles.box_title}>Please select the country</h4>
          <div className="mt-3">{MarketSegmentsDropdown}</div>
          <div className="d-flex mt-4 justify-content-center">
            {/* <button className={styles.btn} onClick={handleCancel}>Cancel</button> */}
            <button onClick={handleConfirm} disabled={!dropdownVal} className={[styles.btn, styles.btn_black].join(' ')}>
              Confirm
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default MarketSegments;
